export default {
    1: {
        'title': 'Prečo začať',
        'message': 'Začať niečo vlastné nie je vôbec jednoduché. Preto ti ukážeme ako na to.'
    },
    2: {
        'title': 'Inšpiruj sa',
        'message': 'Pomôžeme ti vyšpecifikovať tvoj projekt, či sa inšpirovať od iných.'
    },
    3: {
        'title': 'Poraď sa',
        'message': 'Nasmerujeme ťa k tým správnym mentorom a pomôžeme ti nájsť ten správny fit :)'
    },
    4: {
        'title': 'Hľadanie nápadu',
        'message':
            'Budeme ťa sprevádzať pri hľadaní tvojho nápadu alebo ti pomôžeme viac vnímať okolie, ak svoj nápad ešte nemáš.'
    },
    5: {
        'title': 'Zvaliduj si nápad',
        'message': 'Naučíme ťa otestovať svoj nápad a zanalyzovať trh s konkurenciou.'
    },
    6: {
        'title': 'Definuj si hodnoty',
        'message':
            'Ako rozbiehač potrebuješ pracovať nielen na svojom nápade, ale aj na cieli, vízii či hodnotách projektu. V tejto časti si zadefinuješ víziu a hodnoty projektu.'
    },
    7: {
        'title': 'Realizácia nápadu',
        'message': 'Tu sa naučíš premyslieť biznis model a predať nápad do sveta.'
    },
    8: {
        'title': 'Tvorba tímu',
        'message':
            '“Ve dvou se to lépe táhne.” Ak to cítiš rovnako, v tomto kroku ťa naučíme, ako sa dajú tvoriť a rozvíjať malé a veľké tímy.'
    },
    9: {
        'title': 'Rozvíjaj sa',
        'message':
            'Síce si skoro na konci, no rozvíjať sa potrebuješ aj naďalej. Tu ti dáme zaujímavé tipy na osobný a projektový rozvoj.'
    },
    10: {
        'title': 'Pridať projekt',
        'message':
            'Si v závere a my sme na teba hrdí. Prešiel si navýznamnejší krok k tomu, aby si vytvoril niečo veľké! A my sme pripravení ti pomôcť aj naďalej.'
    }
}
